import {
    ContactProfileController,
    ContactProfileControllerScope
} from "../../../contact/controller/contact_profile/ContactProfileController";
import {Partner} from "../../model/Partner";
import {ContactProfileTab} from "../../../contact/model/ContactProfileTab";
import {ContactType} from "../../../contact/model/Contact";

interface Scope extends ContactProfileControllerScope<Partner> {

}

export class PartnerProfileController extends ContactProfileController<Partner, Scope> {

    static instanceConstructor = [
        '$scope',
        '$routeParams',
        'selectedContact',
        PartnerProfileController
    ]

    constructor($scope: Scope,
                $routeParams: ng.route.IRouteParamsService,
                selectedContact: Partner) {
        super($scope, $routeParams, selectedContact);
    }

    protected tabs(): ContactProfileTab[] {
        return [
            ContactProfileTab.BASIC,
            ContactProfileTab.DATE_FIELDS,
            ContactProfileTab.CAMPAIGN_LOG
        ]
    }

    protected contactType(): ContactType {
        return ContactType.PARTNER;
    }

}